module.exports = __webpack_public_path__ + "static/stlouis-a3f2dc10e066625b13168dd52c00bf4c.png";